define('app/views/cart_customer_credit_view',['app/setup', 'app/models/credit'], function(takhfifan, credit) {

  takhfifan.cartCustomerCreditView = Backbone.View.extend({

    events: {
      'click #tkhCreditBtn' : 'submitForm',
      'submit' : 'submitForm',
      'click .tkh-login-link': 'triggerLoginForm',
      'change #user-credit-input #current-credit-discount' : 'showCreditInput',
      'change #user-credit-input' : 'showCreditInput',
      'keyup #creditAmount' : 'disableButton',
      'focus #creditAmount' : 'disableButton',
    },

    template: ( $('#tkh-credit-form-template').length > 0 ) ?
      _.template( $('#tkh-credit-form-template').html() ) : '',

    initialize: function(options) {
      this.model = new takhfifan.Credit();
      var _this = this;
      takhfifan.eventHub.on('customer:login', function(customer) {
        this.isloggedin = true;
        var credit = customer['credit'];
        if (!_.isUndefined(credit)) {
          this.model.set({
            available: Math.floor((credit['balance'] - credit['amount'])/10),
            balance: Math.floor(credit['balance']/10),
            amount: Math.floor(credit['amount']/10),
            cart_has_credit: credit['cart_has_credit']
          });
        }
        _this.render();
      }, this);

      this.model.on('submit:success', function(){
        document.location.reload(true);
      }, this);

      Backbone.Validation.bind(this);
    },

    render: function() {
      if (this.model.get('cart_has_credit')) {
        this.$('.credit-form').hide();
      } else {
        if(this.isloggedin) {
          this.$('.credit-form').html( this.template( this.model.toJSON() ) );
        }
        if(this.model.get('amount') > 0) {
          this.$('#user-credit-input').prop('checked', true);
          this.$('.credit-btn').prop('disabled', false);
        }
        if(this.$("#user-credit-input").is(':checked')) {
          this.$('.credit-form').show();
        }
      }
      this.$('.current-credit.currency em').formatCurrency({
          symbol: '',
          roundToDecimalPlace: '-2'
      });
      this.$('#creditAmount').formatCurrency({
          symbol: '',
          roundToDecimalPlace: '-2'
      });
    },

    submitForm: function(e) {
      e.preventDefault();
      return this.modelSubmit();
    },
    
    modelSubmit: function() {
      var amount = parseInt(this.$('#creditAmount').val().replace(/،/g, ''));

      if (_.isNaN(amount) || this.model.get('amount') == amount) {
        return false;
      }

      this.model.updateAmount(amount);
      this.render();

      if (this.model.isValid()) {
        this.model.submit(this.$('form').prop('action'));
        this.$("#tkhCreditBtn").prop('disabled',true).empty().append('<div class="btn-text"><span class="spinner"></span></div>');
      }
      return false;
    },

    triggerLoginForm: function(event) {
      event.preventDefault();
      takhfifan.eventHub.trigger('customer:loginForm');
      return false;
    },
    
    showCreditInput: function(evt) {
      if($(evt.target).is(':checked')){
        this.render();
      }
      else{
        this.$('.credit-form').hide();
        this.$('#creditAmount').val(0);
        this.modelSubmit();
      }
    },
    disableButton: function(evt) {
      if($(evt.target).val() == ''){
        this.$('.credit-btn').prop('disabled', true);
      }
      else{
        this.$('.credit-btn').prop('disabled', false);
        this.$('#creditAmount').formatCurrency({
            symbol: '',
            roundToDecimalPlace: '-2'
        });
      }
    }
  });

});

